module.exports = __webpack_public_path__ + "static/img/ent-96.90fa4a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-96.jpg
// module id = 4V3C
// module chunks = 51